import { useEffect, useCallback, MutableRefObject, useContext } from 'react';
import noop from 'lodash/noop';
import RootContext from 'ia-react-core/~/components/config/_RootContext';

interface UseDropListItemScrollOptions {
  popperScrollWrapper: MutableRefObject<HTMLUListElement>;
  isOpened: boolean;
  selectedItemIds: string[];
}

const useDropListItemScroll = ({ popperScrollWrapper, isOpened, selectedItemIds }: UseDropListItemScrollOptions) => {
  const { root } = useContext(RootContext);
  const adjustScroll = useCallback(() => {
    // We use this syntax because id may contain weird characters
    const selectedElement: HTMLElement = root.querySelector(`[id="${selectedItemIds[0]}"]`);
    if (selectedElement) {
      popperScrollWrapper.current.scroll(0, selectedElement.offsetTop - (popperScrollWrapper.current.clientHeight / 2) + (selectedElement.clientHeight / 2));
    }
  }, [popperScrollWrapper, selectedItemIds, root]);

  useEffect(() => {
    if (isOpened && selectedItemIds.length) {
      adjustScroll();
      const timer1 = setTimeout(adjustScroll, 20);
      const timer2 = setTimeout(adjustScroll, 50);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }

    return noop;
  }, [adjustScroll, isOpened, popperScrollWrapper, selectedItemIds]);
};

export default useDropListItemScroll;
